import { getPrice } from '@fourthwall/utils'
import {
  SINGLE_UNIT_PRODUCT_ORDER_SHIPPING_FEES,
  SINGLE_UNIT_PRODUCT_ORDER_TAXES_FEES,
  SINGLE_UNIT_PRODUCT_PAYMENT_PROCESSING_FEE_PERCENT,
  SINGLE_UNIT_PRODUCT_PAYMENT_PROCESSING_FEE_VALUE,
} from '@fourthwall/utils/dist/constants'
import React from 'react'
import { InfoTooltip } from '../../../../common/InfoTooltip'
import { Checkbox } from '../../../../inputs/Checkbox'
import * as S from './styled'

export type Props = {
  value: boolean
  onValueChange: (value: boolean) => void
}

export const FeeCheckbox = ({ value, onValueChange }: Props) => {
  return (
    <S.Container>
      <Checkbox
        label="Include estimated payment processing fees"
        value={value}
        onValueChange={onValueChange}
      />
      <S.TooltipWrapper>
        <InfoTooltip
          size="medium"
          content={
            <>
              There is a payment processing fee of $
              {SINGLE_UNIT_PRODUCT_PAYMENT_PROCESSING_FEE_PERCENT}% +
              {getPrice(SINGLE_UNIT_PRODUCT_PAYMENT_PROCESSING_FEE_VALUE)} per transaction (same as
              Shopify). The fee depends on the number of items a supporter buys, as well as any
              shipping and tax fees. We estimate it using an order that contains a single unit of
              this product and has ${SINGLE_UNIT_PRODUCT_ORDER_SHIPPING_FEES} for shipping fees and
              ${SINGLE_UNIT_PRODUCT_ORDER_TAXES_FEES} for taxes.
            </>
          }
        />
      </S.TooltipWrapper>
    </S.Container>
  )
}
